import React from 'react';
import PropTypes from 'prop-types';
import { colors, Typography } from 'kangarootime-ui';
import Close from '../../../assets/svg/close';
import useHover from '../../../hooks/useHover';

const Photo = ({ file, removeFileFromUploadGroup }) => {
  const [isHovered, bind] = useHover();
  const byteToMb = file.size / Math.pow(1024, 2);
  // 4.5mb upload limit
  const fileTooLarge = parseFloat(byteToMb) > 4.5;

  return (
    <div {...bind} style={{ position: 'relative', margin: 4 }}>
      { isHovered &&
        <div
          onClick={removeFileFromUploadGroup}
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            position: 'absolute',
            right: 0,
            top: 0,
            zIndex: 9999,
            cursor: 'pointer'
          }}
        >
          <Close fill={colors.danger} />
        </div>
      }
      <img
        alt='file-to-upload'
        src={URL.createObjectURL(file)}
        style={{ height: 140, width: 140 }}
      />
      { fileTooLarge &&
        <div style={{
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          position: 'absolute',
          width: '100%',
          left: 0,
          top: 0,
          zIndex: 999
        }}>
          <Typography style={{ fontSize: 10, marginLeft: 4 }}>File is too big</Typography>
        </div>
      }
    </div>
  );
};

Photo.propTypes = {
  file: PropTypes.instanceOf(File),
  removeFromDropzone: PropTypes.func
};

export default Photo;
